import { BatchEditCampaignPage } from 'components/BatchEditCampaign/BatchEditCampaignPage';
import { BatchEditCampaignSection } from 'components/BatchEditCampaign/BatchEditCampaignSection';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { InfoDisplaySectionTitle } from 'components/InfoDisplaySection/InfoDisplaySection';
import SummaryDetail from 'components/SummaryDetail/SummaryDetail';
import i18n from 'i18n';
import { useCallback } from 'react';
import { TrackingSummaryStateContentModel } from './TrackingSummaryStateContentModel';

export const TrackingSummaryStateContent: React.FC<{
  model: () => TrackingSummaryStateContentModel;
}> = ({ model: useModel }) => {
  const { trackingSummaryData } = useModel();

  const renderSummaryDetails = useCallback(() => {
    if (!trackingSummaryData) {
      return null;
    }
    return Object.keys(trackingSummaryData).map((key) => {
      if (!trackingSummaryData[key]) {
        return <div key={key} />;
      }
      const content = trackingSummaryData[key].content;
      return (
        <SummaryDetail
          key={key}
          title={trackingSummaryData[key].title}
          data={content}
          prefixColor={trackingSummaryData[key].titlePrefixColor}
        />
      );
    });
  }, [trackingSummaryData]);

  if (!trackingSummaryData) {
    return <LoadingIndicator />;
  }

  return (
    <BatchEditCampaignPage title={i18n.t('modifyTrackingState.title')}>
      <BatchEditCampaignSection
        title={i18n.t('batchEditCampaignSummary.labels.checkYourSettings')}
      >
        <div style={{ padding: '30px' }}>
          <div style={{ marginBottom: '30px', fontWeight: 500 }}>
            <InfoDisplaySectionTitle
              title={i18n.t('batchEditCampaignSummary.titles.trackingSummary')}
            />
          </div>
          {renderSummaryDetails()}
        </div>
      </BatchEditCampaignSection>
    </BatchEditCampaignPage>
  );
};
